import { Pipe, PipeTransform } from '@angular/core';

/** Spojí kód a název číselníkové položky do „kód - název“; bez názvu vrátí jen kód, bez kódu prázdný řetězec. */
export function formatKodNazev(kod: string | number | null | undefined, nazev?: string | null): string {
  if (kod === null || kod === undefined || kod === '') return '';
  return nazev ? `${kod} - ${nazev}` : `${kod}`;
}

/**
 * Spojí kód a název číselníkové položky do „kód - název“.
 * Bez názvu vrátí jen kód, bez kódu prázdný řetězec.
 *
 * @example {{ omezeni.kodAgendy | kodNazev: omezeni.nazevAgendy }}
 */
@Pipe({ name: 'kodNazev', standalone: true })
export class KodNazevPipe implements PipeTransform {
  transform(kod: string | number | null | undefined, nazev?: string | null): string {
    return formatKodNazev(kod, nazev);
  }
}
